import { Col, Row } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import TrackClick from '../../../components/Onetrack/TrackClick';
import { Link } from '../../../utils/i18n';
import image from './form.png';
import styles from './index.module.less';

const Contact: React.FC = () => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <Row align="stretch" justify="space-around">
        <Col xl={12}>
          <div className={styles.content}>
            <img alt="form" src={image} className={styles.image} />
          </div>
        </Col>
        <Col xl={12}>
          <div className={styles.content}>
            <div className={styles.inner}>
              <div className={styles.title}>
                <FormattedMessage id="Contact.Privacy.Team" />
              </div>
              <div className={styles.text}>
                <FormattedMessage id="Home.Contact.Description" />
              </div>
              <TrackClick tip="71.1.2.1.2152">
                <Link to="/contact" className={styles.button}>
                  <FormattedMessage id="Home.Contact.Submit" />
                </Link>
              </TrackClick>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default Contact;
